	import React, { useRef } from 'react'
	import { connect } from 'react-redux'
	import { AppState } from '../reducers'
	import  Slider from "react-slick/lib";
	import "slick-carousel/slick/slick.css";
	import "slick-carousel/slick/slick-theme.css";
		
	const CustomArrow = (props) => {
		const { onClick, classVal } = props;
		return (
			<button className={classVal} onClick={onClick}></button>
		);
	};

	const ImagesGallery = ({ sliderImagesLinks, sliderAutoPlay, sliderAutoPlaySpeed, sliderTransitionSpeed }: ReturnType<typeof mapStateToProps>) => {
		const slider = useRef(null);

		var settings = {
			dots: false,
			infinite: true,
			speed: sliderTransitionSpeed,
			prevArrow: <CustomArrow onClick={slider?.current?.slickPrev()} classVal="custom-arrow slick-custom-prev" />,
    		nextArrow: <CustomArrow onClick={slider?.current?.slickNext()} classVal="custom-arrow slick-custom-next" />,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: sliderAutoPlay,
			autoplaySpeed: sliderAutoPlaySpeed,
			responsive: [
				{
				  settings: {
					slidesToShow: 1
				  }
				}
			]
		};

		const sliderImages = sliderImagesLinks.map((link, index) => (
			<div id='kr-slider-container' key={index}>
				<img
					style={{
						maxHeight:'573.75px',
						width:'100%',
						margin: '0px 0px 10px 0px'
					}}
					alt={`Slide ${index + 1}`}
					src={link}
				/>
			</div>
		));

		return (
			<>
				<Slider ref={slider} {...settings}>
					{sliderImages}
				</Slider>
			</>
		);
	}

	const mapStateToProps = (state: AppState) => {
		return {
			sliderImagesLinks: state.sliderImagesLinks,
			sliderAutoPlay: state.config.sliderAutoPlay,
			sliderAutoPlaySpeed: state.config.sliderAutoPlaySpeed,
			sliderTransitionSpeed: state.config.sliderTransitionSpeed,
		}
	}

	export default connect(mapStateToProps)(ImagesGallery)